// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"c4d6c7e0","390":"cf5e6ceb","535":"c4e6866b","572":"d8b7520c","739":"e7677788","977":"fbac28d8","982":"c8374229"}[chunkId] + ".chunk.js";
};